var _defs, _defs2, _g, _g2, _g3, _defs3, _g4, _defs4, _g5, _defs5, _g6, _defs6, _g7, _g8, _g9, _animateTransform, _animateTransform2, _animateTransform3, _animate, _animate2, _animateTransform4, _animateTransform5, _animateTransform6, _animateTransform7, _animateTransform8, _animateTransform9, _animateTransform10, _animateTransform11, _animateTransform12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarsLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: 12,
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "NONE",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerWidth: 1,
    markerHeight: 1,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }), /*#__PURE__*/React.createElement("marker", {
    id: "ROUND",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerWidth: 1,
    markerHeight: 1,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    cx: 5,
    cy: 5,
    stroke: "context-stroke",
    fill: "context-fill"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "SQUARE",
    viewBox: "0 0 10 10",
    refX: 0,
    refY: 5,
    markerWidth: 1,
    markerHeight: 1,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 5,
    height: 10,
    stroke: "context-stroke",
    fill: "context-fill"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ARROW_LINES",
    viewBox: "0 0 10 10",
    refX: 4,
    refY: 5,
    markerWidth: 10,
    markerHeight: 10,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3095 4.5L0.3255 1.457C0.1315 1.26 0.1355 0.942998 0.3315 0.749998C0.5295 0.556998 0.8455 0.559998 1.0385 0.756998L4.8575 4.65C5.0475 4.844 5.0475 5.156 4.8575 5.35L1.0385 9.243C0.8455 9.44 0.5285 9.443 0.3315 9.25C0.1345 9.057 0.1315 8.74 0.3255 8.543L3.3095 5.5V4.5Z"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ARROW_EQUILATERAL",
    viewBox: "0 0 10 10",
    refX: 6.5,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5L0.5 9.33013L0.5 0.669873L8 5Z"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "TRIANGLE_FILLED",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.96244e-08 5L7.5 9.33013L7.5 0.669873L-5.96244e-08 5Z"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "CIRCLE_FILLED",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    cx: 5,
    cy: 5
  })), /*#__PURE__*/React.createElement("marker", {
    id: "DIAMOND_FILLED",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.000488281,
    y: 5,
    width: 7.07138,
    height: 7.07138,
    transform: "rotate(-45 -0.000488281 5)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 12,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "12_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h55v0v55v0h-55v0v-55z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#12_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 438,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 440,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "440_fill_path",
    d: "M39.96,20c0,2.098 -0.3295,4.184 -0.9769,6.18c-0.6474,1.996 -1.6063,3.878 -2.8391,5.576c-1.2328,1.698 -2.7233,3.19 -4.4196,4.424c-1.6963,1.234 -3.5766,2.194 -5.5706,2.842c-1.994,0.648 -4.0779,0.978 -6.1738,0.978c-2.0959,0 -4.1797,-0.33 -6.1737,-0.978c-1.994,-0.648 -3.8743,-1.608 -5.5706,-2.842c-1.6963,-1.234 -3.1868,-2.726 -4.4196,-4.424c-1.2328,-1.698 -2.1917,-3.58 -2.8391,-5.576c-0.6474,-1.996 -0.977,-4.082 -0.977,-6.18c0,-2.098 0.3296,-4.184 0.977,-6.18c0.6474,-1.996 1.6063,-3.878 2.8391,-5.576c1.2328,-1.698 2.7233,-3.19 4.4196,-4.424c1.6963,-1.234 3.5766,-2.194 5.5706,-2.842c1.994,-0.648 4.0778,-0.978 6.1737,-0.978c2.0959,0 4.1798,0.33 6.1738,0.978c1.994,0.648 3.8743,1.608 5.5706,2.842c1.6963,1.234 3.1868,2.726 4.4196,4.424c1.2328,1.698 2.1917,3.58 2.8391,5.576c0.6474,1.996 0.9769,4.082 0.9769,6.18z",
    fillRule: "nonzero",
    fill: "rgb(255, 199, 199)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,31.4686,5.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 441,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 442,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "442_fill_path",
    d: "M11.98804,9.54899c0,0 0.999,-6.5 -4.49551,-5l0,-1c0,0 -0.999,-2.92755 -3.49651,-3.5c-1.62461,-0.37238 -3.99601,1.5 -3.99601,1.5l0,32c0,0 4.03811,1.77339 5.35397,-1.13922l0.14055,0.13922c0,0 4.03223,1.32969 5.49452,-0.5c1.99801,-2.5 0.999,-5 0.999,-5c0,0 3.99601,-2.5 1.4985,-6l0.999,-0.5c0,0 3.49651,-3 2.99701,-6.5c-0.65127,-4.56344 -5.49452,-4.5 -5.49452,-4.5zM5.99402,10.54899c0,0 -2.49751,-4.90909 1.49851,-6M7.49252,21.049c0,0 3.94108,-2.87698 5.99402,0M2.99701,28.049c0,0 3.49651,1 2.49751,4c-0.04248,0.12757 -0.08946,0.24771 -0.14055,0.36078",
    fillRule: "nonzero",
    fill: "rgb(255, 222, 213)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 443,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "443_stroke_path",
    d: "M5.99402,10.54899c0,0 -2.49751,-4.90909 1.49851,-6c5.49452,-1.5 4.49551,5 4.49551,5c0,0 4.84325,-0.06344 5.49452,4.5c0.4995,3.5 -2.99701,6.5 -2.99701,6.5M7.49252,21.049c0,0 3.94108,-2.87698 5.99402,0c2.49751,3.5 -1.4985,6 -1.4985,6c0,0 0.999,2.49999 -0.999,5c-1.46229,1.82969 -5.49452,0.5 -5.49452,0.5M2.99701,28.049c0,0 3.49651,1 2.49751,4c-1.13678,3.41376 -5.49452,1.5 -5.49452,1.5l0.4995,-32c0,0 1.8719,-1.87237 3.49651,-1.5c2.49751,0.57245 2.99701,3.5 2.99701,3.5",
    fill: "none",
    stroke: "rgb(76, 36, 29)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11.6563,5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 444,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "444_fill_path",
    d: "M16.81533,35.5v4h-5.49451c0,0 -1.68155,0.14695 -2.49751,-1c-1.13717,-1.59847 -0.32392,-4.15766 -0.999,-6c-0.86024,-2.34764 -2.49751,-3.5 -3.99601,-5c-3.84733,-3.85118 -4.29387,-8.11242 -3.49651,-13.5c1.998,-13.5 16.48355,-14 16.48355,-14v23z",
    fillRule: "nonzero",
    fill: "rgb(234, 234, 234)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11.6563,5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 445,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "445_stroke_path",
    d: "M16.31583,0c0,0 -13.98604,0.5 -15.98405,14c-0.79736,5.38758 -0.35082,9.64882 3.49651,13.5c1.4985,1.5 3.13578,2.65236 3.99601,5c0.67508,1.84234 -0.13817,4.40153 0.999,6c0.81596,1.14695 2.49751,1 2.49751,1h5.49451v-4v-12.5l-4.49551,-6l-4.49551,2",
    fill: "none",
    stroke: "rgb(76, 36, 29)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,15.4846,9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 446,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "446_stroke_path",
    d: "M0,8.5c0,0 0.42516,-1.61924 0.999,-2.5c0.60279,-0.9252 1.4985,-2 1.4985,-2M8.49153,0c0,0 -1.63487,0.39994 -2.49751,1c-0.67962,0.47275 -1.4985,1.5 -1.4985,1.5",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,22.2278,46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 447,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 448,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "448_fill_path",
    d: "M0.5,0h10.988c0.27614,0 0.5,0.22386 0.5,0.5v0c0,0.27614 -0.22386,0.5 -0.5,0.5h-10.988c-0.27614,0 -0.5,-0.22386 -0.5,-0.5v0c0,-0.27614 0.22386,-0.5 0.5,-0.5z",
    fillRule: "nonzero",
    fill: "rgb(107, 79, 91)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "448_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5,-1.5 H13.488 V2.5 H-1.5 Z M0.5,0h10.988c0.27614,0 0.5,0.22386 0.5,0.5v0c0,0.27614 -0.22386,0.5 -0.5,0.5h-10.988c-0.27614,0 -0.5,-0.22386 -0.5,-0.5v0c0,-0.27614 0.22386,-0.5 0.5,-0.5z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#448_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "448_stroke_path",
    d: "M0.5,0h10.988c0.27614,0 0.5,0.22386 0.5,0.5v0c0,0.27614 -0.22386,0.5 -0.5,0.5h-10.988c-0.27614,0 -0.5,-0.22386 -0.5,-0.5v0c0,-0.27614 0.22386,-0.5 0.5,-0.5z",
    fill: "none",
    stroke: "rgb(76, 36, 29)",
    strokeWidth: 3,
    strokeLinecap: "none",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 449,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "449_fill_path",
    d: "M0.5,0h10.988c0.27614,0 0.5,0.22386 0.5,0.5v0c0,0.27614 -0.22386,0.5 -0.5,0.5h-10.988c-0.27614,0 -0.5,-0.22386 -0.5,-0.5v0c0,-0.27614 0.22386,-0.5 0.5,-0.5z",
    fillRule: "nonzero",
    fill: "rgb(107, 79, 91)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "449_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5,-1.5 H13.488 V2.5 H-1.5 Z M0.5,0h10.988c0.27614,0 0.5,0.22386 0.5,0.5v0c0,0.27614 -0.22386,0.5 -0.5,0.5h-10.988c-0.27614,0 -0.5,-0.22386 -0.5,-0.5v0c0,-0.27614 0.22386,-0.5 0.5,-0.5z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#449_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "449_stroke_path",
    d: "M0.5,0h10.988c0.27614,0 0.5,0.22386 0.5,0.5v0c0,0.27614 -0.22386,0.5 -0.5,0.5h-10.988c-0.27614,0 -0.5,-0.22386 -0.5,-0.5v0c0,-0.27614 0.22386,-0.5 0.5,-0.5z",
    fill: "none",
    stroke: "rgb(76, 36, 29)",
    strokeWidth: 3,
    strokeLinecap: "none",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.998,5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 450,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "450_fill_path",
    d: "M0,0h7.992v0v1c0,0.55228 -0.44772,1 -1,1h-5.992c-0.55228,0 -1,-0.44772 -1,-1v-1z",
    fillRule: "nonzero",
    fill: "rgb(181, 161, 156)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "450_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5,-1.5 H9.492 V3.5 H-1.5 Z M0,0h7.992v0v1c0,0.55228 -0.44772,1 -1,1h-5.992c-0.55228,0 -1,-0.44772 -1,-1v-1z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#450_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "450_stroke_path",
    d: "M0,0h7.992v0v1c0,0.55228 -0.44772,1 -1,1h-5.992c-0.55228,0 -1,-0.44772 -1,-1v-1z",
    fill: "none",
    stroke: "rgb(76, 36, 29)",
    strokeWidth: 3,
    strokeLinecap: "none",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.997,9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 451,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "451_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5,-1.5 H3.498 V3.5 H-1.5 Z M1.998,1c0,0.1049 -0.0165,0.2092 -0.0489,0.309c-0.0324,0.0998 -0.0803,0.1939 -0.1419,0.2788c-0.0616,0.0849 -0.1362,0.1595 -0.221,0.2212c-0.0848,0.0617 -0.1788,0.1097 -0.2785,0.1421c-0.0997,0.0324 -0.2039,0.0489 -0.3087,0.0489c-0.1048,0 -0.209,-0.0165 -0.3087,-0.0489c-0.0997,-0.0324 -0.1937,-0.0804 -0.2785,-0.1421c-0.0848,-0.0617 -0.1594,-0.1363 -0.221,-0.2212c-0.0616,-0.0849 -0.1095,-0.179 -0.1419,-0.2788c-0.0324,-0.0998 -0.0489,-0.2041 -0.0489,-0.309c0,-0.1049 0.0165,-0.2092 0.0489,-0.309c0.0324,-0.0998 0.0803,-0.1939 0.1419,-0.2788c0.0616,-0.0849 0.1362,-0.1595 0.221,-0.2212c0.0848,-0.0617 0.1788,-0.1097 0.2785,-0.1421c0.0997,-0.0324 0.2039,-0.0489 0.3087,-0.0489c0.1048,0 0.209,0.0165 0.3087,0.0489c0.0997,0.0324 0.1937,0.0804 0.2785,0.1421c0.0848,0.0617 0.1594,0.1363 0.221,0.2212c0.0616,0.0849 0.1095,0.179 0.1419,0.2788c0.0324,0.0998 0.0489,0.2041 0.0489,0.309z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#451_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "451_stroke_path",
    d: "M1.998,1c0,0.1049 -0.0165,0.2092 -0.0489,0.309c-0.0324,0.0998 -0.0803,0.1939 -0.1419,0.2788c-0.0616,0.0849 -0.1362,0.1595 -0.221,0.2212c-0.0848,0.0617 -0.1788,0.1097 -0.2785,0.1421c-0.0997,0.0324 -0.2039,0.0489 -0.3087,0.0489c-0.1048,0 -0.209,-0.0165 -0.3087,-0.0489c-0.0997,-0.0324 -0.1937,-0.0804 -0.2785,-0.1421c-0.0848,-0.0617 -0.1594,-0.1363 -0.221,-0.2212c-0.0616,-0.0849 -0.1095,-0.179 -0.1419,-0.2788c-0.0324,-0.0998 -0.0489,-0.2041 -0.0489,-0.309c0,-0.1049 0.0165,-0.2092 0.0489,-0.309c0.0324,-0.0998 0.0803,-0.1939 0.1419,-0.2788c0.0616,-0.0849 0.1362,-0.1595 0.221,-0.2212c0.0848,-0.0617 0.1788,-0.1097 0.2785,-0.1421c0.0997,-0.0324 0.2039,-0.0489 0.3087,-0.0489c0.1048,0 0.209,0.0165 0.3087,0.0489c0.0997,0.0324 0.1937,0.0804 0.2785,0.1421c0.0848,0.0617 0.1594,0.1363 0.221,0.2212c0.0616,0.0849 0.1095,0.179 0.1419,0.2788c0.0324,0.0998 0.0489,0.2041 0.0489,0.309z",
    fill: "none",
    stroke: "rgb(76, 36, 29)",
    strokeWidth: 3,
    strokeLinecap: "none",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11.988,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 452,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 453,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "453_stroke_path",
    d: "M0,3l2.99701,-3",
    fill: "none",
    stroke: "rgb(76, 36, 29)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246467991473532e-16,1.2246467991473532e-16,1,2.9971,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 454,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "454_stroke_path",
    d: "M0,3l2.99701,-3",
    fill: "none",
    stroke: "rgb(76, 36, 29)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.998,21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 455,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "455_fill_path",
    d: "M1.998,1c0,0.1049 -0.0165,0.2092 -0.0489,0.309c-0.0324,0.0998 -0.0803,0.1939 -0.1419,0.2788c-0.0616,0.0849 -0.1362,0.1595 -0.221,0.2212c-0.0848,0.0617 -0.1788,0.1097 -0.2785,0.1421c-0.0997,0.0324 -0.2039,0.0489 -0.3087,0.0489c-0.1048,0 -0.209,-0.0165 -0.3087,-0.0489c-0.0997,-0.0324 -0.1937,-0.0804 -0.2785,-0.1421c-0.0848,-0.0617 -0.1594,-0.1363 -0.221,-0.2212c-0.0616,-0.0849 -0.1095,-0.179 -0.1419,-0.2788c-0.0324,-0.0998 -0.0489,-0.2041 -0.0489,-0.309c0,-0.1049 0.0165,-0.2092 0.0489,-0.309c0.0324,-0.0998 0.0803,-0.1939 0.1419,-0.2788c0.0616,-0.0849 0.1362,-0.1595 0.221,-0.2212c0.0848,-0.0617 0.1788,-0.1097 0.2785,-0.1421c0.0997,-0.0324 0.2039,-0.0489 0.3087,-0.0489c0.1048,0 0.209,0.0165 0.3087,0.0489c0.0997,0.0324 0.1937,0.0804 0.2785,0.1421c0.0848,0.0617 0.1594,0.1363 0.221,0.2212c0.0616,0.0849 0.1095,0.179 0.1419,0.2788c0.0324,0.0998 0.0489,0.2041 0.0489,0.309z",
    fillRule: "nonzero",
    fill: "rgb(76, 36, 29)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#438",
    attributeName: "transform",
    type: "translate",
    values: "24.5245 26.5;24.5245 26.5;24.5245 26.5",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.59;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#438",
    attributeName: "transform",
    type: "scale",
    values: "1 1;0.7 0.7;1 1",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.59;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform3 || (_animateTransform3 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#438",
    attributeName: "transform",
    type: "translate",
    values: "-24.5245 -26.5;-24.5245 -26.5;-24.5245 -26.5",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.59;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#443_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 109.46515028156675;3.3273070432119796 106.13784323835476;15.303444772036855 94.1617055095299;38.52956527237324 70.9355850091935;68.59454813188475 40.870602149682;92.30838464832712 17.15676563323962;104.73972399218427 4.725426289382482;108.37049877875108 1.0946515028156671;108.38133691244232 1.0838133691244243;108.38133691244232 1.0838133691244243;108.38133691244232 1.0838133691244243;108.38133691244232 1.0838133691244243;108.38133691244232 1.0838133691244243;108.38133691244232 1.0838133691244243",
    dur: "2.52s",
    repeatCount: "indefinite",
    keyTimes: "0;0.08;0.16;0.24;0.32;0.4;0.48;0.56;0.63;0.71;0.79;0.87;0.95;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#443_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "2.52s",
    repeatCount: "indefinite",
    keyTimes: "0;0.08;0.16;0.24;0.32;0.4;0.48;0.56;0.63;0.71;0.79;0.87;0.95;1",
    fill: "freeze"
  })), _animateTransform4 || (_animateTransform4 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#451",
    attributeName: "transform",
    type: "translate",
    values: "1 1;1 1;1 1;1 1",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.57;0.88;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform5 || (_animateTransform5 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#451",
    attributeName: "transform",
    type: "scale",
    values: "0 0;0 0;1 1;1 1",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.57;0.88;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform6 || (_animateTransform6 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#451",
    attributeName: "transform",
    type: "translate",
    values: "-1 -1;-1 -1;-1 -1;-1 -1",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.57;0.88;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform7 || (_animateTransform7 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#452",
    attributeName: "transform",
    type: "translate",
    values: "1.5 1.5;1.5 1.5;1.5 1.5;1.5 1.5",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.54;0.85;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform8 || (_animateTransform8 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#452",
    attributeName: "transform",
    type: "scale",
    values: "0 0;0 0;1 1;1 1",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.54;0.85;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform9 || (_animateTransform9 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#452",
    attributeName: "transform",
    type: "translate",
    values: "-1.5 -1.5;-1.5 -1.5;-1.5 -1.5;-1.5 -1.5",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.54;0.85;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform10 || (_animateTransform10 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#455",
    attributeName: "transform",
    type: "translate",
    values: "1 1;1 1;1 1;1 1",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;0.82;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform11 || (_animateTransform11 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#455",
    attributeName: "transform",
    type: "scale",
    values: "0 0;0 0;1 1;1 1",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;0.82;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform12 || (_animateTransform12 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#455",
    attributeName: "transform",
    type: "translate",
    values: "-1 -1;-1 -1;-1 -1;-1 -1",
    dur: "2.52s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;0.82;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    additive: "sum",
    fill: "freeze"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarsLoading);
export default __webpack_public_path__ + "static/media/tars-loading.3588c0ab.svg";
export { ForwardRef as ReactComponent };